import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlRefound = "Refound"

//* Obtener todas las devoluciones por estatus listado
//*  GET /api/Refound/Status/{IdCatEstatusDevolucio}
export const getDevolucionesEstatusAllLista = async ({IdCatEstatusDevolucion}) => {
    return axios.get(`${APIURL}/${urlRefound}/Status/${IdCatEstatusDevolucion}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return []
        })
}
//* Obtener todas las devoluciones por estatus
//* GET /api/Refound/Status/{Referencia}/{IdCatEstatusDevolucio}/{Pagina}/{Registros}
export const getDevolucionesEstatusAll = async ({ Referencia, IdCatEstatusDevolucion, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlRefound}/Status/${Referencia}/${IdCatEstatusDevolucion}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {}
        })
}

//* Obtener todos las devoluciones pendientes
//* GET /api/Refound/Pending/{Referencia}/{Pagina}/{Registros}
export const getDevolucionesPendientesAll = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlRefound}/Pending/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Obtener todos las devoluciones pendientes por version de paquete
//* GET /api/Refound/Pending/{Referencia}/{Pagina}/{Registros}/{IdCatVersionPaquete}
export const getDevolucionesPendientesAllVersion = async ({ Referencia, Pagina, Registros, IdCatVersionPaquete }) => {
    return axios.get(`${APIURL}/${urlRefound}/Pending/${Referencia}/${Pagina}/${Registros}/${IdCatVersionPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Validar una devolucion pendiente
//* PUT /api/Refound/Validate/{IdDevolucionSolicitud}
export const putValidateDevolucion = async ({ IdDevolucionSolicitud }) => {
    return axios.put(`${APIURL}/${urlRefound}/Validate/${IdDevolucionSolicitud}`,
        {

        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}
//* Obtener todas las devoluciones validas
//* GET /api/Refound/Validate/{Referencia}/{Pagina}/{Registros}
export const getDevolucionesValidasAll = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlRefound}/Validate/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Aceptar la devolucion validas
//* PUT /api/Refound/Accept/{IdDevolucionSolicitud}
export const putAceptarDevolucion = async ({ IdDevolucionSolicitud, IdMoneda, Monto, TipoCambio }) => {
    return axios.put(`${APIURL}/${urlRefound}/Accept/${IdDevolucionSolicitud}`,
        {
            "IdMoneda": IdMoneda,
            "Monto": Monto,
            "TipoCambio": TipoCambio
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}

//* Consultar historico de las devoluciones
//* GET /api/Refound/{Referencia}/{IdCatEstatusDevolucion}/{Pagina}/{Registros}
export const getDevolucionesHistoricoAll = async ({ Referencia, IdCatEstatusDevolucion, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlRefound}/${Referencia}/${IdCatEstatusDevolucion}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

//* Declinar la solictud por parte de finanzas
//* PUT /api/Refound/Decline/Finance/{IdDevolucionSolicitud - Finanzas
export const putDeclinarSolitudRembolsoFinanzas = async ({IdDevolucionSolicitud}) => {
    return axios.put(`${APIURL}/${urlRefound}/Decline/Finance/${IdDevolucionSolicitud}`,
    {
    },
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}
//* Declinar la solictud por parte de agente
//* PUT /api/Refound/Decline/Agent/{IdDevolucionSolicitud} - Agente
export const putDeclinarSolitudRembolsoAgente = async ({IdDevolucionSolicitud}) => {
    return axios.put(`${APIURL}/${urlRefound}/Decline/Agent/${IdDevolucionSolicitud}`,
    {
    },
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}